import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Button,
  Chip,
  Collapse,
  Divider,
  Drawer,
  FormControlLabel,
  Radio,
  RadioGroup,
  Slider,
  TextField,
  Paper,
  Typography,
  Grid
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {

  KeyboardDatePicker,
} from '@material-ui/pickers';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  papercontent: {
      marginTop : theme.spacing(2),
      textAlign : 'center'
  },
  drawer: {
    width: 420,
    maxWidth: '100%'
  },
  header: {
    padding: theme.spacing(2, 1),
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(2, 3),
    flexGrow: 1
  },
  contentSection: {
    padding: theme.spacing(2, 0)
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionContent: {},
  formGroup: {
   
    padding: theme.spacing(1, 0)
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  field: {
    marginTop: 0,
    marginBottom: 0
  },
  flexGrow: {
    flexGrow: 1
  },
  addButton: {
    marginLeft: theme.spacing(1)
  },
  tags: {
    marginTop: theme.spacing(1)
  },
  minAmount: {
    marginRight: theme.spacing(3)
  },
  maxAmount: {
    marginLeft: theme.spacing(3)
  },
  radioGroup: {},
  actions: {
    textAlign: 'right',
    padding: theme.spacing(3),
    paddingRight: theme.spacing(5),
    '& > * + *': {
      margin: theme.spacing(0)
    }
  }
}));

const CommodityDetails = props => {
  const { open, onClose, masters, onSave,usercontent, viewtype, className, ...rest } = props;

  const classes = useStyles();

  const initialValues = {
    name: '',
    nameTamil : '',
    nameTelugu : '',
    imageurl : '',
    commodity : {}

  };

  const [expandProject, setExpandProject] = useState(true);
  const [expandCustomer, setExpandCustomer] = useState(false);
  const [values, setValues] = useState({ ...initialValues });

  const handleClear = () => {
    setValues({ ...initialValues });
  };
  React.useEffect(() => {
    if(usercontent && usercontent.id)
    {
      setValues({
        ...usercontent
      })

    }
 }, [usercontent]);
  const handleFieldChange = (event, field, value) => {
    event.persist && event.persist();
    setValues(values => ({
      ...values,
      [field]: value
    }));
  };

  const handleTagAdd = () => {
    setValues(values => {
      const newValues = { ...values };

      if (newValues.tag && !newValues.tags.includes(newValues.tag)) {
        newValues.tags = [...newValues.tags];
        newValues.tags.push(newValues.tag);
      }

      newValues.tag = '';

      return newValues;
    });
  };
  const handleinputchange = type => e => {
    setValues({
      ...values,
      [type]: e.target.value
    });
  }
  const handleTagDelete = tag => {
    setValues(values => {
      const newValues = { ...values };

      newValues.tags = newValues.tags.filter(t => t !== tag);

      return newValues;
    });
  };
  const handleoptionchange = type => (event, value) => {
   
    setValues(values => ({
      ...values,
      [type]: value
    }));
  }
  const handleToggleProject = () => {
    setExpandProject(expandProject => !expandProject);
  };

  const handleToggleCustomer = () => {
    setExpandCustomer(expandCustomer => !expandCustomer);
  };

  const handleSubmit = event => {
    event.preventDefault();
    onSave && onSave(values);
  };

  const paymentStatusOptions = ['Pending', 'Canceled', 'Completed', 'Rejected'];
  const customerAgeOption = ['18 - 30', '30 - 45', '50 - 60', '60+'];

  return (
  <Paper className={classes.papercontent}> 
      <form
        {...rest}
        className={clsx(classes.root, className)}
        onSubmit={handleSubmit}
      >
        
        <div className={classes.content}>
          <Grid container xs={12} spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
                  
                  id="combo-box-demo"
                  options={masters.commodity}
                  margin="dense"
                  fullWidth
                  disabled={viewtype == 2 ? true : false}
                  value={values.commodity}
                  onChange={handleoptionchange('commodity')}
                  getOptionLabel={(option) => option.label}
                  renderInput={(params) => <TextField {...params} label={"Commodity"} fullWidth margin="dense" variant="outlined" />}
                /> 
            </Grid> 
            <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            disabled={viewtype == 2 ? true : false}
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            value={values.name}
                            onChange={handleinputchange('name')}
                           label="Name (English *)"
                          />
            </Grid>
            <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            disabled={viewtype == 2 ? true : false}
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            label="Name (Tamil *)"
                           value={values.nameTamil}
                           onChange={handleinputchange('nameTamil')}
                          />
            </Grid>
            <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            disabled={viewtype == 2 ? true : false}
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                            label="Name (telugu *)"
                            value={values.nameTelugu}
                            onChange={handleinputchange('nameTelugu')}
                          />
            </Grid>
            <Grid item xs={12}>
                      <TextField
                            variant="outlined"
                            margin="dense"
                            fullWidth
                            autoComplete="off"
                            id="vendordeliverydays"
                            name="vendordeliverydays"
                           label="Image Url"
                           disabled={viewtype == 2 ? true : false}
                           value={values.imageurl}
                           onChange={handleinputchange('imageurl')}
                           
                          />
            </Grid>
            
            
          </Grid>
         
        </div>
        <div className={classes.actions}>
          {/* <Button
            onClick={handleClear}
            variant="contained"
           
          >
            Clear
          </Button> */}
          <Button
            color="primary"
            type="submit"
            variant="contained"
          >
            Update
          </Button>
        </div>
      </form>
      </Paper> 
  );
};

CommodityDetails.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  open: PropTypes.bool.isRequired,
  masters: PropTypes.object
};

export default CommodityDetails;
